import type { LocationQuery } from 'vue-router'

import { UTM_PREFIX } from '@/router/query-params'

const SESSION_HASH_SEPARATOR = ':'

export function getUtmHashFromQuery(query: LocationQuery) {
    const utmPairs = Object.entries(query)
        .filter(([key]) => key.startsWith(UTM_PREFIX))
        .map(([key, value]) => `${key}=${value}`)
        .sort()

    const serialized = utmPairs.join('&')
    let hash = 0

    // simplest hash of string
    for (let idx = 0; idx < serialized.length; idx += 1) {
        hash = (hash << 5) - hash + serialized.charCodeAt(idx)
        hash |= 0
    }

    if (!hash) {
        return ''
    }
    return Math.abs(hash).toString(36)
}

export function buildSessionCookieValue(timestamp: string, utmHash: string) {
    return `${timestamp}${SESSION_HASH_SEPARATOR}${utmHash}`
}

export function parseSessionCookieValue(raw?: string) {
    if (!raw) {
        return { timestamp: undefined, utmHash: '' }
    }

    const [timestamp, utmHash] = raw.split(SESSION_HASH_SEPARATOR)
    return { timestamp, utmHash }
}
